import {FormatIcu} from '@tolgee/format-icu';
// eslint-disable-next-line no-restricted-imports
import {
  BackendFetch,
  DevTools,
  GlobalContextPlugin,
  LanguageDetector,
  LanguageStorage,
  T,
  Tolgee,
  TolgeeProvider,
  useTolgee,
  useTranslate,
} from '@tolgee/react';
import deLocale from 'date-fns/locale/de';
import enLocale from 'date-fns/locale/en-GB';

const localeMap: {[key: string]: Locale} = {
  en: enLocale,
  de: deLocale,
  'de-DE': deLocale,
};

const apexChartLocales: ApexLocale[] = [
  {
    name: 'de',
    options: {
      days: ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'],
      shortDays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
      months: [
        'Januar',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
      ],
      shortMonths: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    },
  },
  {
    name: 'en',
    options: {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      shortDays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
      months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    },
  },
];

const tolgeeInstance = Tolgee()
  .use(GlobalContextPlugin())
  .use(DevTools())
  .use(FormatIcu())
  .use(
    BackendFetch({
      prefix: import.meta.env.VITE_TOLGEE_CONTENT_DELIVERY_PREFIX,
      timeout: 10000, // 10 seconds
    }),
  )
  .use(LanguageDetector())
  .use(LanguageStorage())
  .init({
    defaultLanguage: 'en', // default language
    availableLanguages: ['en', 'de-DE'],
    fallbackLanguage: 'en',
    ns: [
      'common',
      'annotationGuideline',
      'changelog',
      'dashboard',
      'error',
      'defectBook',
      'hotKeys',
      'mainMenu',
      'models',
      'review',
      'settings',
      'signin',
      'tasks',
      'training',
      'user',
      'usersManagement',
    ],
    // for development
    apiUrl: import.meta.env.VITE_TOLGEE_API_URL,
    apiKey: import.meta.env.VITE_TOLGEE_API_KEY,
  });

export {
  tolgeeInstance,
  useTolgee,
  useTranslate as useTranslation,
  localeMap,
  T as Trans,
  apexChartLocales,
  TolgeeProvider,
};

// eslint-disable-next-line no-restricted-imports
export type {TFnType} from '@tolgee/react';
